
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '../../../functions/eventBus';

export interface Texts {
    approve: string;
    reset: string;
    title: string;
}

interface Data {
    isDesktop: boolean;
}

export default {
    props: {
        texts: {
            type: Object as PropType<Texts>,
            default: () => ({
                approve: '',
                reset: '',
                title: '',
            }),
        },
    },

    data(): Data {
        return {
            isDesktop: EventBus.isDesktop,
        };
    },

    computed: {
        ...mapGetters({
            filters: 'search/filters',
        }),

        /**
         * Check if the store has any filters.
         *
         * @return {boolean}
         */
        hasFilters(): boolean {
            return this.filters.length > 0;
        },
    },

    beforeMount(): void {
        EventBus.$on('app.resize', () => {
            this.isDesktop = EventBus.isDesktop;
        });
    },

    beforeUnmount(): void {
        EventBus.$off('app.resize');
    },

    methods: {
        ...mapActions({
            removeFilter: 'search/removeFilter',
            resetFilters: 'search/resetFilters',
        }),
    },
};
